import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NavigateService } from 'src/app/core/services/navigate.service';

@Component({
  selector: 'ms-mago-courses',
  templateUrl: './mago-courses.component.html',
  styleUrls: ['./mago-courses.component.scss']
})
export class MagoCoursesComponent implements OnInit {
  trainingPlans: boolean;

  constructor(
    private route: ActivatedRoute,
    private navigateService: NavigateService
  ) { }

  ngOnInit(): void {
    this.trainingPlans = this.navigateService.getLocalStorageData<boolean>('trainingPlans')
  }

}
